export default {
    LANGUAGE: "English",
    TITLE: "Beginner",
    CHARACTER: "0-m-0",
    TYPE: "LOCAL"
};
